import Axios from 'axios';
import { SERVER_URL } from 'Constants';
import { IUserResult } from 'Models/Store';

export type validate2faCodeArgs = {
	token: string;
	method: string;
	rememberMe?: boolean;
	rememberTwoFactor?: boolean;
};
type validate2faBody = {
	token: string;
	method: string;
	rememberMe?: boolean;
	rememberTwoFactor?: boolean;
};
export function validate2faCode({ token, method, rememberMe, rememberTwoFactor }: validate2faCodeArgs) {
	const body: validate2faBody = { token, method };

	if (rememberMe !== undefined) body.rememberMe = rememberMe;
	if (rememberTwoFactor !== undefined) body.rememberTwoFactor = rememberTwoFactor;

	return Axios.post(`${SERVER_URL}/api/authorization/validate-2fa`, body);
}
export type TwoFactorLoginResponse = {
	type: '2fa-required';
	method: string;
	data: unknown;
};
type LoginBody = {
	username: string;
	password: string;
	rememberMe?: boolean;
};

export type InvalidPasswordResponse = {
	type: 'invalid-password';
	params: { [key in string]: string };
};
export type LoginResponse = IUserResult | TwoFactorLoginResponse | InvalidPasswordResponse;
export function login(username: string, password: string, rememberMe?: boolean): Promise<LoginResponse> {
	const postData: LoginBody = {
		username: username,
		password: password,
	};

	if (rememberMe !== undefined) {
		postData.rememberMe = rememberMe;
	}

	return Axios.post<LoginResponse>(`${SERVER_URL}/api/authorization/login`, postData).then(x => x.data);
}
interface TwoFactorAunthenticationNotRequired {
	twoFactorSetupRequired: false;
}
interface TwoFactorAunthenticationRequired {
	twoFactorSetupRequired: true;
	code: string;
}
type CheckTwoFactorAunthenticationResult = TwoFactorAunthenticationNotRequired | TwoFactorAunthenticationRequired;

export const check2faStatus = async () => {
	const res = await Axios.get<CheckTwoFactorAunthenticationResult>(
		`${SERVER_URL}/api/authorization/check-2fa-status`,
	);
	return res.data;
};

export interface GuestLoginArgs {
	email: string;
	firstName: string;
	lastName: string;
	phone?: string;
	postcode?: string;
	/** The code emailed to a returning guest. Leave out on the first attempt. */
	code?: string;
}

/**
 * What guest-login and convert-guest answer (202) when the email belongs to an existing guest: a code has
 * been emailed to them and the request has to be repeated with it.
 */
export interface EmailCodeRequired {
	code: 'EMAIL_CODE_REQUIRED';
	/** False when the previous code is too recent to replace; nothing was emailed. */
	sent: boolean;
	resendAvailableInSeconds: number;
}

export function isEmailCodeRequired(data: unknown): data is EmailCodeRequired {
	return (data as EmailCodeRequired | undefined)?.code === 'EMAIL_CODE_REQUIRED';
}

export function guestLogin(details: GuestLoginArgs): Promise<IUserResult | EmailCodeRequired> {
	return Axios.post<IUserResult | EmailCodeRequired>(`${SERVER_URL}/api/authorization/guest-login`, details).then(
		res => res.data,
	);
}

export async function guestCreation(details: GuestLoginArgs): Promise<IUserResult> {
	const res = await Axios.post<IUserResult>(`${SERVER_URL}/api/authorization/guest-creation`, details);
	return res.data;
}

export function forceExpireSession(): Promise<void> {
	return Axios.post(`${SERVER_URL}/api/authorization/force-expire`);
}
